import { ShieldAlert, Info } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { BasisBadge, LevelBadge, Panel } from "../trace/Primitives";

const ORDER = { high: 0, medium: 1, low: 2, pass: 3 };

export const RiskIndicators = ({ data }) => {
  const risks = [...data.risks].sort((a, b) => ORDER[a.level] - ORDER[b.level]);
  return (
    <Panel eyebrow="Evidence matrix" title="Risk indicators" icon={ShieldAlert} testId="risk-indicators-panel" className="lg:col-span-3">
      <Accordion type="multiple" className="divide-y divide-trace-line/60">
        {risks.map((r) => (
          <AccordionItem key={r.id} value={r.id} className="border-0" data-testid={`risk-item-${r.id}`}>
            <AccordionTrigger className="gap-3 py-4 hover:no-underline" data-testid={`risk-toggle-${r.id}`}>
              <span className="flex flex-1 flex-wrap items-center gap-3 text-left">
                <LevelBadge level={r.level} testId={`risk-level-${r.id}`} />
                <span className="text-sm font-medium text-white">{r.title}</span>
                <BasisBadge basis={r.basis} />
                <span className="hidden font-mono text-[11px] text-trace-dim sm:inline">src: {r.source}</span>
              </span>
            </AccordionTrigger>
            <AccordionContent>
              <div className="grid gap-4 pb-2 pl-0 sm:pl-[80px] md:grid-cols-2">
                <div>
                  <p className="eyebrow mb-1.5">Why it matters</p>
                  <p className="text-sm leading-relaxed text-trace-muted">{r.why}</p>
                </div>
                <div>
                  <p className="eyebrow mb-1.5">Evidence</p>
                  <ul className="space-y-1.5">
                    {r.evidence.map((e) => <li key={e} className="break-all rounded bg-trace-panel px-2.5 py-1.5 font-mono text-xs text-slate-200">{e}</li>)}
                  </ul>
                </div>
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      {data.third_party_flags.length > 0 && (
        <div className="mt-5 border-t border-trace-line pt-4" data-testid="third-party-flags">
          <p className="eyebrow mb-2">Third-party flags (RugCheck)</p>
          <ul className="flex flex-wrap gap-2">
            {data.third_party_flags.map((f) => (
              <li key={f.name} title={f.description} className="rounded-md border border-trace-line bg-trace-panel px-2.5 py-1 text-xs text-trace-muted">{f.name}</li>
            ))}
          </ul>
        </div>
      )}
      <p className="mt-5 flex items-start gap-2 text-xs leading-relaxed text-trace-dim" data-testid="risk-disclaimer">
        <Info size={14} className="mt-0.5 shrink-0" />
        Indicators describe observable patterns at the time of the scan. A clear result does not mean a token is safe, and a flagged result does not prove wrongdoing. Do your own research.
      </p>
    </Panel>
  );
};
